export enum ButtonStyleTypes {
  primary,
  secondary,
  cancel,
}
